import SelectDocumentStep from './SelectDocumentStep';

export default SelectDocumentStep;
